<!-- ----------------------------------------- 9 Box Master ,Setup, Reports ------------------------------------------ -->

<ion-content class="container">
  <div class="tabs-container">
    <div class="card">
      <ion-row *ngIf="!router.url.includes('Setup')">
        <ion-col size-sm="10" size-md="9" size-lg="9" size-xs="10" class="pl-15 pr-0 pb-0">
          <div class="borderbottomForTab" *ngIf="!router.url.includes('Setup')">
            <mat-tab-group #tabGroup class="pt-10 pr-10" [selectedIndex]="selectedTypeTabIndex"
              (selectedTabChange)="tabTypeChanged($event)">
                 <!-- Dashboard Tab -->
                    <mat-tab label="Dashboard">
                      <ng-template mat-tab-label>
                        <span class="tab-label">
                          <span class="material-icons mr-10">speed</span>Dashboard
                        </span>
                      </ng-template>
                    </mat-tab>
              <mat-tab label="9 Box Master" *ngIf="
                  loggedInUserRole == 'HR Admin' ||
                  loggedInUserRole == 'Super Admin' ||
                  loggedInUserRole == 'PHI Admin' ||
                  loggedInUserRole == 'HOD'
                ">
                <ng-template mat-tab-label>
                  <span class="tab-label">
                    <span class="material-icons mr-10">group</span>9 Box Master
                  </span>
                </ng-template>
 
              </mat-tab>
              <span *ngIf="!bandNotFound" class="regular fs-15 ml-10" style="color: #e94848">The Question is not set for
                you .</span>
              <mat-tab *ngIf="bandNotFound && emptyDepartment == 1" label="Reports">
                <ng-template mat-tab-label>
                  <span class="tab-label">
                    <span class="material-icons mr-10"> description </span>Reports</span>
                </ng-template>
              </mat-tab>
            </mat-tab-group>
          </div>
        </ion-col>
        <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="" class="borderbottomForTab pl-10 pt-10 pr-10" *ngIf="
            !router.url.includes('Setup') &&
            (loggedInUserRole == 'HR Admin' ||
              loggedInUserRole == 'Super Admin' ||
              loggedInUserRole == 'PHI Admin' ||
              loggedInUserRole == 'MD')
          ">
          <!-- <div class="center-content float-right">
            <div>
              <span class="cp fs-14 link font_regular center-content mr-20" (click)="onClickLogs('Logs')">
                <img src="././assets/icon/logsIcon.svg" /><u>Logs</u></span>
            </div>
            <div>
              <button type="button" class="add_btn fs-14 float-right center-content mr-5"
                [style.background-color]="buttonColorName" (click)="onClickSetup('Setup')">
                <span class="material-icons fs-20 mr-5">settings</span>Setup
              </button>
            </div>
          </div> -->

          
         <!-- Right Side Buttons -->
        <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="" class="borderbottomForTab pl-10 pt-10 pr-10">

          <div class="center-content float-right fade-in-right">
            <div>
              <span class="cp fs-14 fs_12ForMobile link font_regular center-content mr-20 logs-link"
                (click)="onClickLogs('Logs')">
                <img src="././assets/icon/logsIcon.svg"><u>Logs</u>
              </span>
            </div>
            <div>
              <button type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content mr-5 setup-btn"
                [style.background-color]="buttonColorName" (click)="onClickSetup('Setup')">
                <span class="material-icons fs-20 mr-5">settings</span>Setup
              </button>
            </div>
          </div>
        </ion-col>

        </ion-col>
      </ion-row>
    </div>

    <!------------------------------------------------------------- Setup Popup ------------------------------------------------->

    <div class="modal fade" [style.display]="showSetupPopup ? 'block' : 'none'">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="mt-10 d-flex pt-5 pb-10 pr-10 pl-0 headerBreadcrumb" (click)="onClickback()">
            <img src="././assets/icon/backArrow.svg" class="cp" />
            <label class="font_semibold fs-18 ml-10 mt-5 black_color">
              <span class="cp">9 Box Leadership Grid</span> /
              <span [style.color]="buttonColorName">Setup</span>
            </label>
          </div>
          <div class="modal-body">
            <mat-card>
              <mat-card-header>
                <div mat-card-title>Setup</div>
              </mat-card-header>
              <mat-card-content>
                <ion-row>
                  <ion-col size="4" class="mt-10">
                    <div class="formLabelRegularfs16 mb-5">Fiscal Year</div>
                    <div class="inputBoxDisabled">
                      {{ sharedService.transform(loggedInCompanyFiscalyear) }}
                    </div>
                  </ion-col>
                  <ion-col size="4">
                    <div class="formLabelRegularfs16">
                      Year<span class="red-cl">&nbsp;*</span>
                    </div>
                    <mat-form-field class="w-100 mat-height40 mat-input-style">
                      <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency" (selectionChange)="
                          getYearSetupForReimbursement(
                            selectedYearForCompetency
                          )
                        ">
                        <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                          {{ sharedService.transformYearToFyFormat(item.year) }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>
                </ion-row>
              </mat-card-content>
            </mat-card>
          </div>

          <!--------------------------------------------------------- Perf vs Potential Grid  ---------------------------------- -->

          <div class="modal-body px-10">
            <mat-card class="custom-card" [class.card-disabled]="!isCurrentYearSelected">
              <mat-card-header>
                <div mat-card-title>Perf vs Potential Grid</div>
              </mat-card-header>
              <div style="padding: 20px" class="tablethird">
                <table mat-table [dataSource]="PerfvsPotentialGrid" class="custom-table mat-elevation-z1">
                  <ng-container matColumnDef="category">
                    <th mat-header-cell *matHeaderCellDef>9 box performance</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.category }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="low">
                    <th mat-header-cell *matHeaderCellDef>Low</th>
                    <td mat-cell *matCellDef="let element; let k = index">
                      <mat-form-field appearance="outline">
                        <input class="color-black" matInput placeholder="Min.."
                          [(ngModel)]="element.performanceScoreLowMin" (input)="onInputChange($event)"
                          pattern="[0-9]*\.?[0-9]*" (blur)="onMaxRangeChangeLowMin(element, k)"
                          [disabled]="editedPerfvsPotential != k" />
                      </mat-form-field>
                      <mat-form-field appearance="outline">
                        <input class="color-black" matInput placeholder="Max.."
                          [(ngModel)]="element.performanceScoreLowMax" (input)="onInputChange($event)"
                          pattern="[0-9]*\.?[0-9]*" (blur)="onMaxRangeChangeLowMax(element, k)"
                          [disabled]="editedPerfvsPotential != k" />
                      </mat-form-field>
                      <!-- Display error message -->
                      <div *ngIf="isInValidLowMinMaxRange[k]" class="red-cl font_regular fs-12">
                        {{ errorMessage[k] }}
                      </div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="medium">
                    <th mat-header-cell *matHeaderCellDef>Medium</th>
                    <td mat-cell *matCellDef="let element; let k = index">
                      <mat-form-field appearance="outline">
                        <span matPrefix>&gt;</span>
                        <input class="color-black" matInput placeholder="Min.."
                          [(ngModel)]="element.performanceScoreLowMax" [disabled]="true" />
                      </mat-form-field>
                      <mat-form-field appearance="outline">
                        <input class="color-black" matInput placeholder="Max.."
                          [(ngModel)]="element.performanceScoreMediumMax" (input)="onInputChange($event)"
                          pattern="[0-9]*\.?[0-9]*" (blur)="onMaxRangeChangeMediumMax(element, k)"
                          [disabled]="editedPerfvsPotential != k" />
                      </mat-form-field>
                      <div *ngIf="isInValidMediumMinMaxRange[k]" class="red-cl font_regular fs-12">
                        {{ errorMediumMessage[k] }}
                      </div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="high">
                    <th mat-header-cell *matHeaderCellDef>High</th>
                    <td mat-cell *matCellDef="let element; let k = index">
                      <mat-form-field appearance="outline" style="height: 15px">
                        <span matPrefix>&gt;</span>
                        <input class="color-black" matInput placeholder="Min.."
                          [(ngModel)]="element.performanceScoreMediumMax" [disabled]="true" />
                      </mat-form-field>
                      <mat-form-field appearance="outline">
                        <input class="color-black" matInput placeholder="Max.."
                          [(ngModel)]="element.performanceScoreHighMax" (input)="onInputChange($event)"
                          pattern="[0-9]*\.?[0-9]*" (blur)="onMaxRangeChangeHighMax(element, k)"
                          [disabled]="editedPerfvsPotential != k" />
                      </mat-form-field>
                      <div *ngIf="isInValidHighMinMaxRange[k]" class="red-cl font_regular fs-12">
                        {{ errorHighMessage[k] }}
                      </div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element; let i = index">
                      <div class="d-flex" *ngIf="!isCheckPerformancePotential[i]">
                        <img (click)="updatePotentialGrid(element, i)" *ngIf="editedPerfvsPotential != i"
                          class="ml-5 p-20 cp imgEdit" title="Update" src="././assets/icon/edit.png" />
                        <span (click)="closePotentialGrid(i)" *ngIf="editedPerfvsPotential === i"
                          class="material-icons close cp fs-20" style="padding-left: 5.7px">close</span>
                        <span *ngIf="editedPerfvsPotential === i" (click)="!isLoading && editPotentialGrid(element, i)"
                          title="Update" class="material-icons link cp fs-20"
                          style="position: relative; left: 10px">check</span>
                      </div>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedThirdTableColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedThirdTableColumns"></tr>
                </table>
              </div>
            </mat-card>
          </div>

          <!--------------------------------------------------------- 9 Boxes Names  ------------------------------ -->

          <div class="modal-body px-10">
            <mat-card class="custom-card" [class.card-disabled]="!isCurrentYearSelected">
              <mat-card-header>
                <div mat-card-title>9 Boxes Names</div>
              </mat-card-header>
              <div style="padding: 20px">
                <table class="custom-table mat-elevation-z1 tableFourth" style="width: 100%; table-layout: fixed">
                  <tr class="mainHeading">
                    <th style="width: 30%">Positioning</th>
                    <th style="width: 60%">Name</th>
                    <th style="width: 10%"></th>
                  </tr>
                  <tr *ngFor="let item of positions; let k = index">
                    <th>{{ item.positioning }}</th>
                    <td>
                      <mat-form-field class="mat-height40 mat-input-style" style="width: 100%">
                        <input class="color-black" matInput placeholder="Type here..." [(ngModel)]="item.name"
                          (keyup)="checkMaxLength(item.name)" [disabled]="editedIndividualScoreId != k"
                          style="width: 100%" maxlength="100" />
                      </mat-form-field>
                    </td>
                    <td>
                      <div class="d-flex">
                        <img (click)="onClickIndividualNames(item, k)" *ngIf="editedIndividualScoreId != k"
                          class="ml-4 mt-10 cp imgEdit" title="Update" src="././assets/icon/edit.png" />
                        <span (click)="onClosePositioning(item, k)" *ngIf="editedIndividualScoreId === k"
                          class="material-icons close cp fs-20" style="padding-left: 13px">close</span>
                        <span *ngIf="editedIndividualScoreId === k" (click)="
                            !isLoading && onClickIndividualScoreEdit(item, k)
                          " class="material-icons editbutton link cp fs-20" [class.disabled]="isLoading"
                          style="padding-left: 13px">check</span>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </mat-card>
          </div>

          <!-- ------------------------------------------------- Potential Questionnaire Table  ----------------------------------------- -->

          <!-- <div class="modal-body px-10">
            <mat-card class="custom-card" [class.card-disabled]="!isCurrentYearSelected">
              <mat-card-header>
                <div mat-card-title>Potential Questionnaire Table</div>
              </mat-card-header>
              <div style="padding: 20px;">
                <div *ngFor="let table of arrQuestionsList; let tableIndex = index" class="table-container">
                  <div class="d-flex justify-between align-center">
                    <h3>
                      <span class="material-icons fs-20 red cp" (click)="deleteBand(table.band)">delete</span>
                    </h3>
                  </div>
                  <div *ngIf="weightageErrorMessages[tableIndex]" class="weightageError">
                  </div>
                  <table class="custom-table mat-elevation-z1 tableFourth"
                    style="width: 100%; table-layout: fixed; padding: 20px !important;">
                    <tr class="mainHeading">
                      <th style="width: 15%;">Band {{ table.band }}</th>
                      <th style="width: 35%;">Questions</th>
                      <th style="width: 15%;">Weightage</th>
                      <th style="width: 5%;">
                        <div class="font_semibold addnewbtn fs-14 cp" (click)="addRow(tableIndex)">
                          + Add
                        </div>
                      </th>
                    </tr>
                    <tr *ngFor="let row of table.question ? table.question : []; let i = index">
                      <td>
                        <mat-form-field class="mat-height40 mat-input-style" style="width: 100%;">
                          <mat-select placeholder="Select an option" [(ngModel)]="table.band">
                            <mat-option [value]="table.band">
                              {{ table.band }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </td>
                      <td>
                        <mat-form-field class="w-100 mat-height40 mat-input-style">
                          <input matInput type="text" style="color: black !important;" class="font_regular"
                            placeholder="Type here..." [(ngModel)]="row.question"
                            (ngModelChange)="checkDuplicateQuestion(row, tableIndex,i)" [disabled]="editedScoreId !=i">
                        </mat-form-field>
                      </td>
                      <td>
                        <mat-form-field class="w-100 mat-height40 mat-input-style" style="width: 100%;">
                          <input class="font_regular" matInput placeholder="Type here..." [(ngModel)]="row.weightage"
                            [disabled]="editedScoreId !=i" (keypress)="restrictToNumbers($event)"
                            (ngModelChange)="limitWeightage(row, tableIndex)" />
                        </mat-form-field>
                      </td>
                      <td>
                        <div class="d-flex justify-content-center" *ngIf="!duplicateErrors[tableIndex]">
                          <img (click)="onClickQuestionslNames(row, i,tableIndex)" *ngIf="editedScoreId !=i"
                            class="ml-5 mt-10   cp imgEdit" title="Update" src="././assets/icon/edit.png">
                          <span (click)="onClosePositioningQuestions(row, i,tableIndex)" *ngIf="editedScoreId ===i"
                            class="material-icons close cp fs-20">close</span>
                          <span *ngIf="editedScoreId ===i" (click)="onClickQuestionsScoreEdit(row,i,tableIndex)"
                            class="material-icons link editbutton cp fs-20">check</span>
                        </div>
                      </td>
                    </tr>
                    <tr *ngIf="duplicateErrors[tableIndex]">
                      <td colspan="2" class="text-left questionError font-bold"> <mat-error>This question already
                          exists!</mat-error></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td colspan="2" class="text-right totalWeightage font-bold">Total Weightage:</td>
                      <td>
                        <mat-form-field class="mat-height40 mat-input-style" style="width: 100%;">
                          <input class="color-black" matInput [(ngModel)]="totalWeightage[tableIndex]" disabled />
                        </mat-form-field>
                      </td>
                      <td>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </mat-card>
          </div> -->
          <div class="modal-body px-10">
            <mat-card class="custom-card" [class.card-disabled]="!isCurrentYearSelected">
              <mat-card-header>
                <div mat-card-title>Potential Questionnaire Table</div>
              </mat-card-header>
              <div style="padding: 20px">
                <div *ngFor="let table of arrQuestionsList; let tableIndex = index" class="table-container">
                  <div class="d-flex justify-between align-center">
                    <h3>
                      <span class="material-icons fs-20 red cp" (click)="deleteBand(table.band)">delete</span>
                    </h3>
                  </div>
                  <div *ngIf="weightageErrorMessages[tableIndex]" class="weightageError"></div>

                  <table class="custom-table mat-elevation-z1 tableFourth" style="
                      width: 100%;
                      table-layout: fixed;
                      padding: 20px !important;
                    ">
                    <tr class="mainHeading">
                      <th style="width: 15%">Band {{ table.band }}</th>
                      <th style="width: 35%">Questions</th>
                      <th style="width: 15%">Weightage</th>
                      <th style="width: 5%">
                        <div class="font_semibold addnewbtn fs-14 cp" (click)="addRow(tableIndex)">
                          + Add
                        </div>
                      </th>
                    </tr>

                    <tr *ngFor="
                        let row of table.question ? table.question : [];
                        let i = index
                      ">
                      <td>
                        <mat-form-field class="mat-height40 mat-input-style" style="width: 100%">
                          <mat-select placeholder="Select an option" [(ngModel)]="table.band">
                            <mat-option [value]="table.band">{{
                              table.band
                              }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </td>

                      <td>
                        <mat-form-field class="w-100 mat-height40 mat-input-style">
                          <input matInput type="text" style="color: black !important" class="font_regular"
                            placeholder="Type here..." [(ngModel)]="row.question" maxlength="255"
                            (keyup)="checkMaxLengthForQue(row.question)" (ngModelChange)="
                              checkDuplicateQuestion(row, tableIndex, i)
                            " [disabled]="editedScoreId !== tableIndex + '-' + i" />
                        </mat-form-field>
                      </td>

                      <td>
                        <mat-form-field class="w-100 mat-height40 mat-input-style" style="width: 100%">
                          <input class="font_regular" matInput placeholder="Type here..." [(ngModel)]="row.weightage"
                            [disabled]="editedScoreId !== tableIndex + '-' + i" (keypress)="restrictToNumbers($event)"
                            (ngModelChange)="limitWeightage(row, tableIndex)" />
                        </mat-form-field>
                      </td>

                      <td>
                        <div class="d-flex justify-content-center" *ngIf="!duplicateErrors[tableIndex]">
                          <img (click)="onClickQuestionslNames(row, i, tableIndex)"
                            *ngIf="editedScoreId !== tableIndex + '-' + i" class="ml-5 mt-10 cp imgEdit" title="Update"
                            src="././assets/icon/edit.png" />

                          <span (click)="
                              onClosePositioningQuestions(row, i, tableIndex)
                            " *ngIf="editedScoreId === tableIndex + '-' + i"
                            class="material-icons close cp fs-20">close</span>

                          <span *ngIf="editedScoreId === tableIndex + '-' + i" (click)="
                              onClickQuestionsScoreEdit(row, i, tableIndex)
                            " class="material-icons link editbutton cp fs-20">check</span>
                        </div>
                      </td>
                    </tr>

                    <tr *ngIf="duplicateErrors[tableIndex]">
                      <td colspan="2" class="text-left questionError font-bold">
                        <mat-error>This question already exists!</mat-error>
                      </td>
                      <td></td>
                      <td></td>
                    </tr>

                    <tr>
                      <td colspan="2" class="text-right totalWeightage font-bold">
                        Total Weightage:
                      </td>
                      <td>
                        <mat-form-field class="mat-height40 mat-input-style" style="width: 100%">
                          <input class="color-black" matInput [(ngModel)]="totalWeightage[tableIndex]" disabled />
                        </mat-form-field>
                      </td>
                      <td></td>
                    </tr>
                  </table>
                </div>
              </div>
            </mat-card>
          </div>
        </div>
      </div>
    </div>

    <!--------------------------------------------------------- Nine Box Master------------------------------------------------------------------------- -->

    <div *ngIf="selectedTypeTabName == '9 Box Master'" style="padding: 20px !important">
      <span *ngIf="
          nineBoxesNames != 9 ||
          potentialScoreLength == 0 ||
          performanceScoreLength == 0
        " class="regular fs-12 ml-10" style="color: #e94848">Setup not completed</span>
      <ion-row class="p-5 mt-20" *ngIf="
          nineBoxesNames == 9 &&
          potentialScoreLength != 0 &&
          performanceScoreLength != 0
        ">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="card">
            <ion-row>
              <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3">
                <ng-select class="w250 placeholderText" placeholder="Select Department" [(ngModel)]="selectDepartname"
                  [clearable]="false" (change)="NineBoxMasterDepartmentChange($event)">
                  <ng-option [value]="item.id" *ngFor="let item of frequencyDeptName">
                    <div style="display: flex; justify-content: space-between">
                      <span>{{ item.id }}</span>
                      <span>{{ item.scored }}/{{ item.total }}</span>
                    </div>
                  </ng-option>
                </ng-select>
              </ion-col>
              <ion-col size-sm="9" size-md="9" size-lg="9" size-xs="9">
                <div class="d-flex justify-content-flex-end mt-15">
                  <div class="d-flex">
                    <button *ngIf="loggedInUserRole != 'HOD' && selectDepartname" type="button" class="back_btn fs-14"
                      [style.color]="buttonColorName" [ngClass]="{
                        'disabled-freeze-btn':
                          frozenDepartments[
                            selectDepartname +
                              '_' +
                              loggedInUserCompanyID +
                              '_' +
                              selectedYearForCompetency
                          ]
                      }" [disabled]="
                        frozenDepartments[
                          selectDepartname +
                            '_' +
                            loggedInUserCompanyID +
                            '_' +
                            selectedYearForCompetency
                        ]
                      " [style.border-color]="buttonColorName" (click)="vpApproval('Freeze for the HOD')">
                      Freeze for the HOD
                    </button>
                  </div>
                </div>
              </ion-col>
            </ion-row>
            <div class="table-container">
              <div *ngIf="!isAllBandsEmpty() && !isAllWeightageValid()" class="weightageError">
                Total weightage should be 100 for each employee
              </div>
              <div *ngIf="isAllBandsEmpty()" class="dataNotFoundError">
                Please Select Department
              </div>
              <ion-row>
                <ion-col size="12" size-md="4" class="icons-right">
                  <!-- Refresh Icon -->
                  <span class="ml-10 fs-20 material-icons btn-reset" style="cursor: pointer"
                    [class.clicked]="isNineBoxResetClicked" (click)="resetNineBoxMaster()"
                    (animationend)="isNineBoxResetClicked = false">
                    refresh
                  </span>

                  <!-- Download Icon -->
                  <span class="ml-10 fs-20 material-icons icon-download" style="cursor: pointer"
                    (click)="onBtExport('Nine Box Master')">
                    download
                  </span>
                </ion-col>
              </ion-row>

              <mat-sidenav-container style="height: 100%">
                <!-- Main Content with AG Grid -->
                <!-- template -->
                <!-- template -->
                <mat-sidenav-content>
                  <ag-grid-angular style="width: 100%" class="ag-theme-quartz" [gridOptions]="gridOptions"
                    [columnDefs]="nineBoxColumnDefs" [rowData]="questionsArray1"
                    (gridReady)="onNineBoxGridReady($event)" [pagination]="pagination"
                    [paginationPageSize]="paginationPageSize" [paginationPageSizeSelector]="paginationPageSizeSelector"
                    [localeText]="{ noRowsToShow: 'No Data Found' }">
                  </ag-grid-angular>
                </mat-sidenav-content>
                <!-- Right Side Sidenav -->
              </mat-sidenav-container>
              <!-- <table class="custom-table mat-elevation-z1 tableFourth" style="padding: 20px !important;">
                <tr class="mainHeading">
                  <th>Band</th>
                  <th>Employee</th>
                  <th>Questions</th>
                  <th>Wt(%)</th>
                  <th>Score By HOD</th>
                  <th>Total Score</th>
                  <th>Final Score</th>
                </tr>
                <ng-container *ngFor="let item of nineboxData;trackBy: trackByFn">
                  <tr *ngFor="let que of item.questions; let j = index;trackBy: trackByQuestion">

                    <td *ngIf="j === 0" [attr.rowspan]="item.questions.length">{{ item.band }}</td>
                    <td *ngIf="j === 0" [attr.rowspan]="item.questions.length">{{ item.firstName }} {{ item.lastName }}
                      <p *ngIf="!isWeightageValid(item)" class="weightageErrorForEmployee">Total weightage should be 100
                      </p>
                    </td>
                    <td>{{ que.question }}</td>
                    <td>{{que.weightage}}</td>
                    <td>
                      <mat-form-field class="w-300 mat-height40 mat-input-style">
                        <input
                          matInput
                          placeholder="type here......."
                          [(ngModel)]="que.hodScore"
                          (keypress)="restrictToNumbers($event)"
                          (ngModelChange)="onHodScoreChange(item, que)"
                          [disabled]="
                            item.freeze ||
                            !isWeightageValid(item) ||
                            frozenDepartments[selectDepartname + '_' + loggedInUserCompanyID + '_' + selectedYearForCompetency]
                          "
                        />
                      </mat-form-field>
                    </td>
                    
                    <td>{{ que.totalScore }}</td>
                    <td *ngIf="j === 0" [attr.rowspan]="item.questions.length"> {{item.finalScore}}</td>
                  </tr>
                </ng-container>
              </table> -->
            </div>
          </div>
        </ion-col>
      </ion-row>

      <!-- ----------------------------------------------- Performance vs Potential  ---------------------------- -->

      <div class="card" id="PerformancevsPotential" *ngIf="
          nineBoxesNames == 9 &&
          potentialScoreLength != 0 &&
          performanceScoreLength != 0 &&
          selectDepartname
        ">
        <div class="table-container">
          <ion-row class="ion-align-items-center ion-justify-content-between mt-10">
            <ion-col>
              <h4 class="ml-10">Performance vs Potential</h4>
            </ion-col>
            <ion-col class="ion-text-right">
              <span class="PerformancevsPotentialDownload">
                <img (click)="
                    downloadNineBoxPDF(
                      'Performance vs Potential',
                      'PerformancevsPotential'
                    )
                  " src="././assets/icon/downloadIcon.svg" alt="" class="cp" />
              </span>
            </ion-col>
          </ion-row>

          <div class="axis-container mt-20">
            <div class="y-axis-title">
              <span class="y-axis-text">Potential</span>
              <svg width="30" height="250">
                <line x1="15" y1="230" x2="15" y2="20" stroke="navy" stroke-width="3" />
                <polygon points="8,20 22,20 15,5" fill="navy" />
              </svg>
            </div>

            <!-- Y-Axis Labels -->
            <div class="y-axis">
              <div class="y-axis-label">High</div>
              <div class="y-axis-label">Moderate</div>
              <div class="y-axis-label">Low</div>
            </div>
            <div class="d-flex flex-column">
              <div *ngIf="performanceDta?.length > 0" class="grid-container">
                <div class="cell" (click)="openEmployeeTooltip(cell)" *ngFor="let cell of performanceDta"
                  [ngClass]="cell.cssClass" [style.boxShadow]="'0 4px 6px rgba(0, 0, 0, 0.1)'"
                  [style.borderRadius]="'10px'" [style.padding]="'20px'" [style.height]="'130px'"
                  [style.transition]="'all 0.3s ease-in-out'" [style.cursor]="'pointer'">
                  <div class="score">
                    {{ cell.count }}
                  </div>
                  <div class="description">{{ cell.category }}</div>
                </div>
              </div>

              <div class="x-axis">
                <div class="x-axis-label">Low</div>
                <div class="x-axis-label">Moderate</div>
                <div class="x-axis-label">High</div>
              </div>
              <div class="x-axis-title">
                <svg width="500" height="20">
                  <line x1="10" y1="10" x2="480" y2="10" stroke="navy" stroke-width="3" />
                  <polygon points="490,10 475,5 475,15" fill="navy" />
                </svg>
                <span>Performance</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="selectedTypeTabName == 'Reports'" style="margin: 20px !important">
      <ion-row class="p-5 mt-5">
        <ion-row *ngIf="!router.url.includes('Setup')">
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="pl-15 pr-0 pb-0">
            <div class="borderbottomForTab" *ngIf="!router.url.includes('Setup')">
              <mat-tab-group #tabGroup class="pt-10 pr-10" [selectedIndex]="selectedTypeTabIndexForReport"
                (selectedTabChange)="tabTypeChangedForReport($event)">
                <!-- *ngIf= "!(loggedInUserRole == 'Employee')|| findLogdinUserAsaAuthority" -->
                <mat-tab label="dumpReport">
                  <ng-template mat-tab-label>
                    <span style="display: contents">
                      <span class="material-icons mr-10"> report </span>Dump
                      Report</span>
                  </ng-template>
                </mat-tab>

                <mat-tab label="Eployee trends Across Year">
                  <ng-template mat-tab-label>
                    <span style="display: contents">
                      <span class="material-icons mr-10"> description </span>Employee Trends Across Years</span>
                  </ng-template>
                </mat-tab>
              </mat-tab-group>
            </div>
          </ion-col>
        </ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="card">
            <div *ngIf="selectedTypeTabNameForReport == 'dumpReport'">
              <ion-row class="ml-20">
                <ion-col size="3" class="mb-10">
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency" (selectionChange)="
                        getYearSetupForDumpReport(selectedYearForCompetency)
                      ">
                      <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                        {{ sharedService.transformYearToFyFormat(item.year) }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>

                <ion-col size="3">
                  <ng-multiselect-dropdown class="w250 ml-10 mat mat-height40 mat-input-style" [placeholder]="
                      'Select Department' +
                      (selectedCountForDumpreportDepartment > 1
                        ? ' +' + (selectedCountForDumpreportDepartment - 1)
                        : '')
                    " [settings]="dropdownSettings" [data]="getDepartmentsList" [(ngModel)]="selectedDepartments"
                    (onSelect)="getDashBoardDeptWise()" (onDeSelect)="getDashBoardDeptWiseonDeSelect()"
                    (onSelectAll)="selectAllDeptWiseDashboard()" (onDeSelectAll)="onDeSelectAllDeptWiseDashboard()">
                  </ng-multiselect-dropdown>
                </ion-col>
                <ion-col size="12" size-md="4" class="icons-right">
                  <!-- Refresh Icon -->
                  <span class="ml-10 fs-20 material-icons btn-reset" style="cursor: pointer"
                    [class.clicked]="isDumpResetClicked" (click)="resetGrid(); isDumpResetClicked = true"
                    (animationend)="isDumpResetClicked = false">
                    refresh
                  </span>

                  <!-- Download Icon -->
                  <span class="ml-10 fs-20 material-icons icon-download" style="cursor: pointer"
                    (click)="downloaDumpReport()">
                    download
                  </span>
                </ion-col>
                 <!-- <ion-col size="3">
                  <span class="dumpReportDownload">
                    <img (click)="downloaDumpReport()" src="././assets/icon/downloadIcon.svg" alt="" class="cp">
                  </span>
                </ion-col>  -->
              </ion-row>
              <div class="table-container">
                <!-- <ion-row class="ion-align-items-center ion-justify-content-between"> -->

                <!-- LEFT SIDE: SEARCH BOX -->
                <!-- <ion-col size="12" size-md="4">
                    <mat-form-field class="mat-height40 mat-input-style w-100">
                      <mat-icon matPrefix>search</mat-icon>
                      <input matInput type="search" placeholder="Search" [(ngModel)]="searchDumpReport"
                        (input)="filterDumpReport(searchDumpReport);">
                    </mat-form-field>
                  </ion-col>
                 -->
                <!-- RIGHT SIDE: REFRESH + DOWNLOAD ICONS -->
        

                <!-- </ion-row> -->

                <div class="dumpreport">
                  <div *ngFor="let department of departments;">
                    <ng-container *ngIf="
                        groupedData &&
                        groupedData[department] &&
                        groupedData[department].length > 0
                      ">
                      <h6 style="font-weight: bold">
                        Department: {{ department }}
                      </h6>
                      <!-- 
                        <table class="custom-table mat-elevation-z1 tableFourth" style="background-color: white;">
                          <tr class="mainHeading">
                            <th>Band</th>
                            <th>Employee</th>
                            <th>Questions</th>
                            <th>Wt(%)</th>
                            <th>Score By HOD</th>
                            <th>Total Score</th>
                            <th>Final Score</th>
                            <th>PMS Score</th>
                            <th>Category</th>
                          </tr>
                          <ng-container *ngFor="let item of groupedData[department]">
                            <tr *ngFor="let que of item.questions; let i = index">
                              <td *ngIf="i === 0" [attr.rowspan]="item.questions.length">{{ item.band }}</td>
                              <td *ngIf="i === 0" [attr.rowspan]="item.questions.length">{{ item.firstName }} {{
                                item.lastName }}</td>
                              <td>{{ que.question }}</td>
                              <td>{{ que.weightage }}</td>
                              <td>{{ que.hodScore }}</td>
                              <td>{{ que.totalScore }}</td>
                              <td *ngIf="i === 0" [attr.rowspan]="item.questions.length">{{ item.finalScore }}</td>
                              <td *ngIf="i === 0" [attr.rowspan]="item.questions.length">{{ item.kpiScore }}</td>
                              <td *ngIf="i === 0" [attr.rowspan]="item.questions.length">{{ item.category }}</td>
                            </tr>
                          </ng-container>
                        </table> -->
                      <mat-sidenav-container style="height: 100%">
                        <!-- Main Content with AG Grid -->
                        <mat-sidenav-content>
                          <ag-grid-angular style="width: 100%; height: 300px" class="ag-theme-quartz"
                            [rowData]="flattenedDataByDept[department]" [columnDefs]="columnDefsDumpReport"
                            [gridOptions]="gridOptions" [defaultColDef]="defaultColDef"
                            (gridReady)="onGridReady($event)" (rowClicked)="onDumpRowClicked($event)"
                            [pagination]="pagination" [paginationPageSize]="paginationPageSize"
                            [paginationPageSizeSelector]="
                              paginationPageSizeSelector
                            " [detailRowAutoHeight]="detailRowAutoHeight"
                            [localeText]="{ noRowsToShow: 'No Data Found' }">
                          </ag-grid-angular>
                        </mat-sidenav-content>
                      </mat-sidenav-container>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="
                selectedTypeTabNameForReport == 'Eployee trends Across Year'
              ">
              <div class="card">
                <ion-row class="m-10 ion-align-items-center"
                  style="display: flex; align-items: center; flex-wrap: nowrap">
                  <!-- Department Dropdown -->
                  <ion-col size="auto">
                    <ng-multiselect-dropdown style="width: 300px" class="ml-10 mat mat-height40 mat-input-style"
                      [placeholder]="'Select Department'" [settings]="dropdownSettings" [data]="getDepartmentsList"
                      [(ngModel)]="selectedDepartmentEmployeeTrends" (onSelect)="getSelectededEmployeeTrends()"
                      (onDeSelect)="getDeSelectedEMployeeTrends()" (onSelectAll)="selectAllEmployeeTrends($event)"
                      (onDeSelectAll)="onDeSelectAllEmployeeTrends()">
                    </ng-multiselect-dropdown>
                  </ion-col>

                  <!-- Band Dropdown
                  <ion-col size="auto">
                    <ng-multiselect-dropdown style="width:300px;"
                      class="ml-10 mat mat-height40 mat-input-style"
                      [placeholder]="'Select Band'"
                      [settings]="bandDropdownSettings"
                      [data]="uniqueBands"
                      [(ngModel)]="selectedtrendsBands"
                      (onSelect)="onBandSelect()"
                      (onDeSelect)="onBandDeSelect()"
                      (onSelectAll)="onSelectAllBands($event)"
                      (onDeSelectAll)="onDeSelectAllBands()">
                    </ng-multiselect-dropdown>
                  </ion-col>
                
                  Employee Dropdown
                  <ion-col size="auto">
                    <ng-multiselect-dropdown style="width:300px;"
                      class="ml-10 mat mat-height40 mat-input-style"
                      [placeholder]="'Select Employee'"
                      [settings]="employeeDropdownSettings"
                      [data]="uniqueEmployees"
                      [(ngModel)]="selectedEmployeeTrends"
                      (onSelect)="onEmployeeSelect()"
                      (onDeSelect)="onEmployeeDeSelect()"
                      (onSelectAll)="onSelectAllEmployees($event)"
                      (onDeSelectAll)="onDeSelectAllEmployees()">
                    </ng-multiselect-dropdown>
                  </ion-col>
                 -->
                  <!-- RIGHT SIDE ICONS -->
                  <ion-col style="
                      display: flex;
                      justify-content: flex-end;
                      align-items: center;
                    ">
                    <span class="ml-10 mt-10 fs-20 material-icons btn-reset" [class.clicked]="isTrendResetClicked"
                      (click)="resetTrendGrid(); isTrendResetClicked = true"
                      (animationend)="isTrendResetClicked = false">
                      refresh
                    </span>

                    <span class="ml-10 mt-10 fs-20 material-icons icon-download cp"
                      (click)="onBtExport('Employee Trend - Details')">
                      download
                    </span>
                  </ion-col>
                </ion-row>

                <div class="table-container trendtable">
                  <ion-row class="p-5 mt-5">
                    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                      <!-- <table class="custom-table mat-elevation-z1 tableAccrossYear">
                        <tr class="mainHeading">
                          <th>Year</th>
                          <th>Employee</th>
                          <th>Band</th>
                          <th>Department</th>
                          <th>Potential Score</th>
                          <th>Performance Score</th>
                          <th>9 Box Category</th>

                        </tr>
                        <ng-container *ngFor="let employee of employeetrendAccrossyear">
                          <tr *ngFor="let trend of employee.trends">

                            <td>{{ trend.year }}</td>
                            <td>{{ employee.employee }}</td>
                            <td>{{ employee.band }}</td>
                            <td>{{ employee.department }}</td>

                            <td>{{ trend.totalScore }}</td>
                            <td>{{ trend.kpiScore }}</td>
                            <td>{{ trend.category }}</td>
                          </tr>
                        </ng-container>
                      </table>  -->
                      <mat-sidenav-container style="height: 100%">
                        <!-- Main Content with AG Grid -->
                        <mat-sidenav-content>
                          <ag-grid-angular style="width: 100%; height: 320px" class="ag-theme-quartz"
                            [rowData]="flattenedTrendData" [columnDefs]="columnDefsEmployeeTrend"
                            [gridOptions]="gridOptions" [defaultColDef]="defaultColDef"
                            (gridReady)="onTrendGridReady($event)" (rowClicked)="onTrendRowClicked($event)"
                            [pagination]="pagination" [paginationPageSize]="paginationPageSize"
                            [paginationPageSizeSelector]="
                              paginationPageSizeSelector
                            " [detailRowAutoHeight]="detailRowAutoHeight"
                            [localeText]="{ noRowsToShow: 'No Data Found' }" [domLayout]="'autoHeight'">
                          </ag-grid-angular>
                        </mat-sidenav-content>
                      </mat-sidenav-container>
                    </ion-col>
                  </ion-row>
                </div>
              </div>
            </div>
          </div>
        </ion-col>
      </ion-row>
    </div>
    <div *ngIf="
        selectedTypeTabName === 'Dashboard' && !router.url.includes('Setup')
      " style="margin: 20px !important">
      <app-nine-box-dashboard></app-nine-box-dashboard>
    </div>
    <!-- <div *ngIf="selectedTypeTabName === 'Dashboard' && !router.url.includes('Setup')">
      <app-nine-box-dashboard></app-nine-box-dashboard>
    </div> -->
  </div>
</ion-content>